var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tick Square 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bulk/Tick-Square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick-Square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    opacity: 0.4,
    d: "M32.6805 4H15.3405C8.56049 4 4.00049 8.76 4.00049 15.84V32.18C4.00049 39.24 8.56049 44 15.3405 44H32.6805C39.4605 44 44.0005 39.24 44.0005 32.18V15.84C44.0005 8.76 39.4605 4 32.6805 4Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M21.6269 30.4969C21.1789 30.4969 20.7309 30.3269 20.3889 29.9849L15.6429 25.2389C14.9589 24.5549 14.9589 23.4469 15.6429 22.7649C16.3269 22.0809 17.4329 22.0789 18.1169 22.7629L21.6269 26.2729L29.8829 18.0169C30.5669 17.3329 31.6729 17.3329 32.3569 18.0169C33.0409 18.7009 33.0409 19.8089 32.3569 20.4929L22.8649 29.9849C22.5229 30.3269 22.0749 30.4969 21.6269 30.4969Z",
    fill: "#E5B910"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.bef1c98ec42f3346e9995dd4c9968a83.svg";
export { ForwardRef as ReactComponent };